import { render, staticRenderFns } from "./mainRouter.vue?vue&type=template&id=7a1b2ba4"
import script from "./mainRouter.vue?vue&type=script&lang=js"
export * from "./mainRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a1b2ba4')) {
      api.createRecord('7a1b2ba4', component.options)
    } else {
      api.reload('7a1b2ba4', component.options)
    }
    module.hot.accept("./mainRouter.vue?vue&type=template&id=7a1b2ba4", function () {
      api.rerender('7a1b2ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/mainRouter.vue"
export default component.exports